module.exports = __webpack_public_path__ + "static/deleoppbetaling-1cbe12a0780a032b77b0c76c0fa3d6e0.png";